import { render, staticRenderFns } from "./picture-upload.vue?vue&type=template&id=380f40b7&scoped=true&"
import script from "./picture-upload.vue?vue&type=script&lang=js&"
export * from "./picture-upload.vue?vue&type=script&lang=js&"
import style0 from "./picture-upload.vue?vue&type=style&index=0&id=380f40b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f40b7",
  null
  
)

export default component.exports